import { useEffect, useState } from "react";
import API from "../lib/api";
import Reveal from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

const LAYOUT = [
  "lg:col-span-4 lg:col-start-1",
  "lg:col-span-4 lg:col-start-5",
  "lg:col-span-4 lg:col-start-9",
];

export default function Gallery() {
  const { lang, t } = useLang();
  const [items, setItems] = useState(null);

  useEffect(() => {
    API.get("/gallery")
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]));
  }, []);

  const no = lang === "no";

  return (
    <section id="gallery" className="bg-paper py-24 sm:py-32" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="ttwk-label" data-testid="gallery-eyebrow">
            {t.gallery.eyebrow}
          </p>
          <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
            <h2 className="max-w-xl font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
              {t.gallery.heading}
            </h2>
            <p className="max-w-xs pb-2 text-base leading-relaxed text-umber/70">{t.gallery.sub}</p>
          </div>
        </Reveal>

        {items === null && (
          <p className="py-32 text-center font-serif text-2xl italic text-umber/50" data-testid="gallery-loading">
            {t.gallery.loading}
          </p>
        )}

        {items !== null && items.length === 0 && (
          <p className="py-32 text-center font-serif text-2xl italic text-umber/50" data-testid="gallery-empty">
            {t.gallery.empty}
          </p>
        )}

        <div className="mt-16 grid gap-16 sm:gap-20 lg:grid-cols-12 lg:gap-x-10">
          {(items || []).map((item, i) => (
            <figure key={item.piece_id || i} className={`${LAYOUT[i % LAYOUT.length]} w-full`} data-testid={`gallery-item-${i}`}>
              <Reveal delay={(i % 3) * 0.12}>
                <div className="img-frame group overflow-hidden rounded-sm border border-clay/60">
                  <img
                    src={item.image_url}
                    alt={no ? item.alt_no : item.alt_en}
                    className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <figcaption className="mt-5 flex max-w-sm flex-col gap-2">
                  <span className="ttwk-label">№ {i + 1}</span>
                  <span className="font-serif text-2xl font-light italic">{no ? item.title_no : item.title_en}</span>
                  <span className="text-sm leading-relaxed text-umber/75">{no ? item.caption_no : item.caption_en}</span>
                </figcaption>
              </Reveal>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
